import React from "react";
import { useTranslation } from "react-i18next";
import { EmptyPeopleIllustration } from "@dreamhub/designsystem/icons";
import Text from "@/components/ui/text";
import NewPersonButton from "./NewPersonButton";
import { cn } from "@/utils/utils";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import { getEnumTKey } from "@/utils/strings";

interface EmptyStateProps {
  onAddPeople: () => void;
  entityType?: EntityType;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  onAddPeople,
  entityType = EntityType.DEAL,
  className
}) => {
  const { t } = useTranslation();

  const entityName = t(
    getEnumTKey("entities", "names", EntityType, entityType)
  ).toLowerCase();

  return (
    <div className={cn("flex flex-col w-full pt-44 items-center", className)}>
      <div className="flex gap-12 items-center">
        <div className="w-[300px] shrink-0 [&>svg]:w-full [&>svg]:h-auto">
          <EmptyPeopleIllustration />
        </div>
        <div className="flex flex-col gap-10 items-start w-[330px]">
          <div className="flex flex-col gap-6">
            <Text variant="lgSubtitle" className="normal-case">
              {t("detailedView.peopleTab.empty", { entityName })}
            </Text>
            <Text variant="lgBodySecondary">
              {t("detailedView.peopleTab.emptyDescription", { entityName })}
            </Text>
          </div>
          <NewPersonButton onClick={onAddPeople} isDealMode={entityType === EntityType.DEAL} />
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
